import debounce from 'lodash/debounce'
import { ref } from 'vue'

let screenSize = ref(window.innerWidth)

const resizeListener = debounce(() => {
  screenSize.value = window.innerWidth
}, 150)

window.addEventListener('resize', resizeListener)

export const screenSizePlugin = {
  install(app) {
    app.config.globalProperties.$screenSize = screenSize
  },
}
